'use client'

import React from 'react'

import { Footer, Header, PageWrapper } from 'Components/Blocks'
import { Hero } from 'Components/Sections/_Legacy/Faq'
import { Column, Row } from 'Components/UI'
import { AllFaqPagesData } from 'Data/types'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

type Props = {
  data: AllFaqPagesData
}

function FaqPage({ data }: Props) {
  return (
    <PageWrapper secondary>
      <Header />

      <Column alignCenter fullWidth overflowX="hidden">
        <Row height={[76, 76, 92]} />
      </Column>

      <Column as="main" grow px={LANDING_INLINE_PADDINGS} py={7}>
        <Hero data={data?.allFaqPages} />
      </Column>

      <Footer />
    </PageWrapper>
  )
}

export default FaqPage
